// extracted by mini-css-extract-plugin
export default {"SubscribeForm":"SubscribeForm_SubscribeForm__LSx3t","Form":"SubscribeForm_Form__nXJk7","Link":"SubscribeForm_Link__d3Q2G"};